import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const app = createApp(App);

const TeachMeArabicPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f2f8f7',
            100: '#e1eeeb',
            200: '#b8d8d0',
            300: '#8abeb1',
            400: '#529f8c',
            500: '#25866e',
            600: '#017256',
            700: '#015d46',
            800: '#014a38',
            900: '#02392b',
            950: '#02271e',
        },
    },
});

app.use(PrimeVue, {
    theme: {
        preset: TeachMeArabicPreset,
        options: {
            ripple: true,
            // prefix: 'p',
            darkModeSelector: 'light',
        },
    },
});

app.use(router);

app.mount("#app");
